import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaTimesCircle, FaCalendarTimes } from 'react-icons/fa';
import { useApi } from '../../api';
import logo from '../assets/logo_anduze.png';

const CancelarCita = () => {
  const { token } = useParams();
  const api = useApi();
  const [cita, setCita] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [cancelando, setCancelando] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await api.get(`${process.env.REACT_APP_API_URL}/api/citas/cancelar/`, {
          params: { token },
        });
        setCita(res.data);
      } catch (err) {
        setError('No encontramos una cita con este enlace.');
      } finally {
        setCargando(false);
      }
    };
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleCancelar = async () => {
    setCancelando(true);
    try {
      const res = await api.post(`${process.env.REACT_APP_API_URL}/api/citas/cancelar/`, { token });
      setCita(res.data);
    } catch (err) {
      setError('No se pudo cancelar la cita. Intenta de nuevo.');
    } finally {
      setCancelando(false);
    }
  };

  return (
    <>
      <div style={{
        position: 'fixed', inset: 0, zIndex: -1,
        background: 'linear-gradient(135deg, #0a1a3c 0%, #0d3a94 100%)',
      }} />

      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', fontFamily: 'Poppins, Segoe UI, sans-serif', padding: '2rem 1rem',
      }}>
        <img
          src={logo}
          alt="Autocars Anduze"
          style={{ width: 100, marginBottom: 22, filter: 'drop-shadow(0 4px 18px rgba(0,0,0,0.35))' }}
        />

        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.5, type: 'spring', bounce: 0.18 }}
          style={{
            width: '100%', maxWidth: 420,
            background: 'rgba(255,255,255,0.10)',
            backdropFilter: 'blur(22px)',
            WebkitBackdropFilter: 'blur(22px)',
            borderRadius: 24,
            border: '1.5px solid rgba(255,255,255,0.22)',
            boxShadow: '0 24px 64px rgba(0,0,0,0.35)',
            padding: '2rem 1.8rem',
            textAlign: 'center',
            color: '#fff',
          }}
        >
          {cargando && <p style={{ color: 'rgba(255,255,255,0.7)' }}>Cargando...</p>}

          {!cargando && error && (
            <>
              <FaTimesCircle style={{ fontSize: 42, color: '#ff6b6b', marginBottom: 10 }} />
              <p style={{ color: 'rgba(255,255,255,0.8)' }}>{error}</p>
            </>
          )}

          {!cargando && cita && !error && (
            <>
              <FaCalendarTimes style={{ fontSize: 40, color: '#ffd166', marginBottom: 10 }} />
              <h3 style={{ fontWeight: 700, margin: '0 0 12px' }}>Cancelar cita</h3>
              <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: 4 }}>
                Cita del <strong>{cita.fecha}</strong> a las <strong>{cita.hora}</strong>
              </p>
              <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13.5, marginBottom: 20 }}>
                Vehículo: <strong>{cita.placa}</strong>
              </p>

              {cita.estado === 'cancelada' ? (
                <div style={{ color: '#5ce18b', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                  <FaCheckCircle /> Esta cita ya fue cancelada.
                </div>
              ) : (
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleCancelar}
                  disabled={cancelando}
                  style={{
                    width: '100%', padding: '12px 0', borderRadius: 14, border: 'none',
                    background: cancelando ? 'rgba(211,47,47,0.5)' : 'linear-gradient(90deg, #c62828 0%, #e53935 100%)',
                    color: '#fff', fontWeight: 700, fontSize: 15, cursor: cancelando ? 'not-allowed' : 'pointer',
                    fontFamily: 'inherit',
                  }}
                >
                  {cancelando ? 'Cancelando...' : 'Cancelar cita'}
                </motion.button>
              )}
            </>
          )}

          <div style={{ marginTop: 22 }}>
            <Link to="/" style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, textDecoration: 'none' }}>
              ← Volver al inicio
            </Link>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default CancelarCita;
